import {ErrorMessages} from 'constants/Errors';
import {Routes} from 'constants/routes';

import axios from 'axios';
import {setErrorAC} from 'store/app/appSlice';
import store from 'store/store';
import {isAxiosError} from 'typescript/guards/AxiosGuards';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

httpClient.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem('token')!);
  if (token) config.headers.Authorization = token;
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isAxiosError(error) && error?.response?.status === 401) {
      store.dispatch(setErrorAC(ErrorMessages.TOKEN));
      localStorage.clear();
      window.location.replace(`${process.env.REACT_APP_URL}${Routes.LOGIN}`);
    } else throw error;
  },
);

export default httpClient;
